import { render } from "./HeadingThree.vue?vue&type=template&id=13da829d&scoped=true"
import script from "./HeadingThree.vue?vue&type=script&lang=js"
export * from "./HeadingThree.vue?vue&type=script&lang=js"

import "./HeadingThree.vue?vue&type=style&index=0&id=13da829d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13da829d"]])

export default __exports__